import axios from "axios";
import { apiUrl, getIpAddress, getLocation } from "./api";

const api = axios.create({
  baseURL: apiUrl,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

api.interceptors.request.use(
  async (config) => {
    const client = JSON.parse(localStorage.getItem("client") ?? "{}");
    if (!client?.username) {
      window.location.href = "/user/verify";
      return config;
    }
   const [ip, location] = await Promise.all([
      getIpAddress(),
      getLocation(),
    ]);

    const extraData = {
      username: client?.username,
      user_type: "teacher",
      ip,
      latitude: location.latitude,
      longitude: location.longitude,
    };

    const method = (config.method || "").toLowerCase();

    if (["post", "put", "patch"].includes(method)) {
      if (config.data instanceof FormData) {
        Object.entries(extraData).forEach(([key, value]) => {
          config.data.set(key, value ?? "");
        });
      } else {
        config.data = {
          ...(config.data || {}),
          ...extraData,
        };
      }
    }

    if (method === "get") {
      config.params = {
        ...(config.params || {}),
        ...extraData,
      };
    }

    config.headers.Accept = "application/json";
    config.headers["x-client-username"] = client?.username;
    config.headers["x-client-id"] = client?.id;
    config.headers["x-user-type"] = "teacher";
    config.headers["x-type"] = "software";

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const LoginPost = async (data) => {
  try {
    return await api.post("/login/post", data);
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};
export const LoginSendOtp = async (data) => {
  return await api.post("/login/send/otp", data);
};
export const LoginVerifyOtp = async (data) => {
  return await api.post("/login/verify/otp", data);
};
